import {RestResource} from '../rest'
import {athubAxios} from '../../util'
import {EQUIPMENT_IN_OUT_SERVER} from "@/api";

const registerAuth = new RestResource({server: EQUIPMENT_IN_OUT_SERVER, resource: 'registerauth'});

registerAuth.list = (params) => {
    let url = `${EQUIPMENT_IN_OUT_SERVER}/registerauth/list`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.data == 200) {
                resolve(responseBody.data.result);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default registerAuth;